// 组件对象，大写
import arrToStr from './arrToStr.vue'
export default arrToStr
